import { z } from 'zod'

export const STRATALYST_NOTIFICATION_ANALYTICS_CONTRACT_VERSION = '1.0.0' as const
export const stratalystNotificationAnalyticsResponseSchema = z.unknown()
export type StratalystNotificationAnalyticsResponse = z.infer<typeof stratalystNotificationAnalyticsResponseSchema>
